import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractRoomTool } from "./tools";
import { CameraPath } from './../mdl/geo/CameraPath';
import { RoomElement } from './../mdl/RoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
import { RoomManager, AddEnding } from "../RoomManager";
import { Util } from "../utils/Util";
import { CameraMode } from '@egr/wcf/modules/core/view/CameraControl';
import { PointerButton, PointerInfo } from "@egr/wcf/modules/core/view/InputState";
import { InsertElements } from "@egr/wcf/modules/core/cmd";
import { InteractionMode } from "@egr/wcf/modules/core/tool";
import { MainArticleElement } from '@egr/wcf/modules/cf';
import { eq } from "@egr/wcf/modules/utils/math";
export class Area2D extends AbstractRoomTool {
    constructor(pRoomManager, pType, pCurvedRoad = true) {
        if (pType === "CameraPath") {
            super(pRoomManager, new Vector3(0, RoomManager.ROOM_CameraPathHeight, 0));
        }
        else {
            super(pRoomManager);
            this.mRoomManager.shapeToolStarted();
        }
        this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
        this.mTouchMode = false;
        this.mMayCreateArea2D = false;
        this.mFirstSpline = false;
        this.mSecondSpline = false;
        this.mDownPushed = false;
        this.mType = pType;
        this.mCurvedRoad = pCurvedRoad;
        this.mRightClicked = false;
        this.maddEnding = null;
    }
    get type() {
        return (this.mType);
    }
    initialize(pRoomElement, pAddEnding) {
        this.mRoomElement = pRoomElement;
        this.mPoints = this.mRoomElement.Params.ElementPoints.slice();
        this.maddEnding = pAddEnding;
    }
    start(pParameter) {
        this.mView = null;
        this.mTouchMode = false;
        this.mMayCreateArea2D = false;
        this.mFirstSpline = false;
        this.mSecondSpline = false;
        this.mDownPushed = false;
        this.mGridSnapping = false;
        this.mselectedGrid = null;
        if (this.maddEnding == null) {
            this.mPoints = new Array();
            // check on existing camera path if type is "cameraPath"
            if (this.mType === "CameraPath" && this.mRoomManager.cameraPathExists()) {
                this.stop();
                return (false);
            }
        }
        if (this.mType === "Grid") {
            this.mApp.viewer.view.cameraControl.cameraMode = CameraMode.Top;
            const tinserted = this.checkInsertGrip();
            if (tinserted) {
                this.stop();
                return (false);
            }
        }
        document.body.style.cursor = "crosshair";
        this.setInteractionMode(InteractionMode.Primary);
        // special handling for line tool;
        // if grid element exists and line tool was started -> create grid snapping points
        const tGrid = this.checkOnGridSelected();
        if (this.mType === "Line" && tGrid != null) {
            if (tGrid.type === "Grid") {
                this.mselectedGrid = tGrid;
                this.mGridSnapping = true;
                this.mRESnapping.prepareSnapping(tGrid);
            }
            else {
                this.mRESnapping.prepareSnapping();
            }
        }
        else {
            this.mRESnapping.prepareSnapping();
        }
        this.mApp.model.beginSelectionChange();
        return (super.start(pParameter));
    }
    // tslint:disable-next-line:cyclomatic-complexity
    stop(premoveLastPoint = true) {
        super.stop();
        switch (this.mType) {
            case "Spline":
                this.finishSpline(premoveLastPoint);
                break;
            case "Rectangle":
                this.finishRectangle();
                break;
            case "Line":
                this.finishLine();
                break;
            case "Circle":
                this.finishCircle();
                break;
            case "CustomBuilding":
                this.finishCustomBuilding(premoveLastPoint);
                break;
            case "Road":
                this.finishRoad(premoveLastPoint);
                break;
            case "Hedge":
                this.finishHedge(premoveLastPoint);
                break;
            case "Fence":
                this.finishFence(premoveLastPoint);
                break;
            case "CameraPath":
                this.finishCameraPath(premoveLastPoint);
                break;
            case "Grid":
                this.finishGrid();
                break;
            default:
                break;
        }
        document.body.style.cursor = "default";
        if (this.mView != null) {
            this.mView.cameraControl.dblClickZoomToFitEnabled = true;
        }
        //this.mApp.model.setSelection(null);
        this.mRoomManager.endInteraction();
        this.mRoomManager.shapeToolStopped();
        this.mApp.model.endSelectionChange();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePointerDown(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d(tPointer.position);
        this.mView = this.mRoomManager.view;
        if (this.mView != null) {
            this.mView.cameraControl.dblClickZoomToFitEnabled = false;
        }
        switch (this.mType) {
            case "Spline":
                this.handlePDown_Spline(tPos, pState);
                break;
            case "Line":
                this.handlePDown_Line(tPos, pState);
                break;
            case "Rectangle":
                this.handlePDown_Rectangle(tPos, pState);
                break;
            case "Circle":
                this.handlePDown_Circle(tPos, pState);
                break;
            case "CustomBuilding":
                this.handlePDown_CustomBuilding(tPos, pState);
                break;
            case "Road":
                this.handlePDown_Road(tPos, pState);
                break;
            case "Hedge":
                this.handlePDown_Hedge(tPos, pState);
                break;
            case "Fence":
                this.handlePDown_Fence(tPos, pState);
                break;
            case "CameraPath":
                this.handlePDown_CameraPath(tPos, pState);
                break;
            case "Grid":
                this.handlePDown_Grid(tPos, pState);
                break;
            default:
                break;
        }
        if (this.mTouchMode) {
            this.mMayCreateArea2D = true;
        }
        else if (this.mPoints.length === 0) {
            this.startArea2D(tPos);
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePointerUp(pEvent, pState) {
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d(tPointer.position);
        if (pState.isPrimaryPointer(pEvent) && this.mTouchMode && this.mMayCreateArea2D) {
            let tDist = Vector2.Distance(tPointer.initialPosition, tPointer.position);
            switch (this.mType) {
                case "Spline":
                    this.handlePUp_Spline(tPos, tDist);
                    break;
                case "Line":
                    this.handlePUp_Line(tPos, tDist);
                    break;
                case "Rectangle":
                    this.handlePUp_Rectangle(tPos, tDist);
                    break;
                case "Circle":
                    this.handlePUp_Circle(tPos, tDist);
                    break;
                case "CustomBuilding":
                    this.handlePUp_CustomBuilding(tPos, tDist);
                    break;
                case "Road":
                    this.handlePUp_Road(tPos, tDist);
                    break;
                case "Hedge":
                    this.handlePUp_Hedge(tPos, tDist);
                    break;
                case "Fence":
                    this.handlePUp_Fence(tPos, tDist);
                    break;
                case "CameraPath":
                    this.handlePUp_CameraPath(tPos, tDist);
                    break;
                case "Grid":
                    this.handlePUp_Grid(tPos, tDist);
                    break;
                default:
                    break;
            }
        }
        else {
            this.mMayCreateArea2D = false;
            //stop on right mouse click
            if (PointerInfo.IsMousePointer(pEvent) && tPointer.initialButton === PointerButton.Right) {
                let tDist = Vector2.Distance(tPointer.initialPosition, tPointer.position);
                if (eq(tDist, 0)) {
                    this.mPoints.pop();
                    this.mRightClicked = true;
                    this.stop(true);
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePointerMove(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent) && !pState.isMouseHoverPointer(pEvent))
            return;
        let tPointerPos = null;
        if (pState.isMouseHoverPointer(pEvent))
            tPointerPos = this.mApp.viewer.inputState.pointerPosition;
        else {
            let tPointer = pState.pointers.get(pEvent.pointerId);
            if (tPointer == null)
                return;
            tPointerPos = tPointer.position;
            //start wall creation in touch mode
            if (tPointer != null && (this.mPoints.length === 0) && this.mTouchMode && this.mMayCreateArea2D) {
                let tDist = Vector2.Distance(tPointer.initialPosition, tPointer.position);
                if (tDist > 10) {
                    let tPosInit = this.getPlanePickPos2d(tPointer.initialPosition);
                    this.startArea2D(tPosInit);
                }
            }
        }
        let tPos = this.getPlanePickPos2d(tPointerPos);
        switch (this.mType) {
            case "Spline":
                this.handlePMove_Spline(tPos, pState);
                break;
            case "Line":
                this.handlePMove_Line(tPos, pState);
                break;
            case "Rectangle":
                this.handlePMove_Rectangle(tPos, pState);
                break;
            case "Circle":
                this.handlePMove_Circle(tPos, pState);
                break;
            case "CustomBuilding":
                this.handlePMove_CustomBuilding(tPos, pState);
                break;
            case "Road":
                this.handlePMove_Road(tPos, pState);
                break;
            case "Hedge":
                this.handlePMove_Hedge(tPos, pState);
                break;
            case "Fence":
                this.handlePMove_Fence(tPos, pState);
                break;
            case "CameraPath":
                this.handlePMove_CameraPath(tPos, pState);
                break;
            case "Grid":
                this.handlePMove_Grid(tPos, pState);
                break;
            default:
                break;
        }
        if (tPos != null) {
            this.updatePointerPosition(tPos);
        }
    }
    checkOnGridSelected() {
        if (this.mApp.model.selection.length === 0) {
            return (null);
        }
        const tsel = this.mApp.model.selection[0];
        if (tsel instanceof RoomElement && tsel.type === "Grid") {
            if (tsel.REforGrid_REF != null) {
                return (tsel);
            }
        }
        return (null);
    }
    getScreenScaleFactor(pPoint) {
        //get screen scale factor
        let tScaleFactor = 1.0;
        if (pPoint != null) {
            let tView = this.mRoomManager.view;
            if (tView != null) {
                let tDist = tView.projectedDistance(pPoint, pPoint.add(tView.cameraControl.right.scale(0.1)));
                tScaleFactor = tDist != null ? 1.0 / tDist : 0.1;
                tScaleFactor *= tView.pixelScaleFactor;
            }
        }
        return tScaleFactor;
    }
    performSnapping(pPos) {
        return (this.mRESnapping.snap(pPos, this.mView));
    }
    updatePointerPosition(pPos) {
        this.mApp.viewer.requestRenderFrame();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_Spline(pPos, pState) {
        if (pPos == null)
            return;
        let tnewPos = this.performSnapping(pPos);
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(tnewPos);
            this.mPoints.push(tnewPos);
            this.mFirstSpline = true;
            let tSpline = this.mRoomManager._insertSpline(this.mPoints);
            if (tSpline != null) {
                this.mRoomElement = tSpline;
                this.mRESnapping.prepareSnapping(this.mRoomElement);
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.setToolRunning(true);
            }
        }
        else {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else if (tnewPos != null) {
                        this.mPoints.push(tnewPos);
                        this.mDownPushed = true;
                    }
                }
                else if (tnewPos != null) {
                    this.mPoints.push(tnewPos);
                    this.mDownPushed = true;
                }
            }
            else if (tnewPos != null && this.mRoomElement != null) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    let tPlast = new Vector3(0, 0, 0);
                    tPlast.x = this.mPoints[0].x;
                    tPlast.y = this.mPoints[0].y;
                    tPlast.z = this.mPoints[0].z;
                    this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                    this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                    this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                    if (this.mRoomElement.geometry.getType() === "Spline") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                    this.stop();
                }
                else if (this.mPoints.length >= 3) {
                    let tlastIdx = this.mPoints.length - 1;
                    if (Util.vectorEquals3(this.mPoints[tlastIdx], this.mPoints[tlastIdx - 1])) {
                        return;
                    }
                    this.mPoints.push(tnewPos);
                    if (this.mRoomElement.geometry.getType() === "Spline") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
                else {
                    this.mPoints.push(tnewPos);
                    if (this.mRoomElement.geometry.getType() === "Spline") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
            }
        }
    }
    handlePDown_Rectangle(pPos, pState) {
        if (pPos == null)
            return;
        let tnewPos = this.performSnapping(pPos);
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            let tPos1 = tnewPos.clone();
            let tPos2 = tnewPos.clone().add(new Vector3(0, 0, -0.1));
            let tPos3 = tnewPos.clone().add(new Vector3(0.1, 0, -0.1));
            let tPos4 = tnewPos.clone().add(new Vector3(0.1, 0, 0));
            this.mPoints.push(tPos1);
            this.mPoints.push(tPos2);
            this.mPoints.push(tPos3);
            this.mPoints.push(tPos4);
            let tRectangle = this.mRoomManager._insertRectangle(this.mPoints);
            if (tRectangle != null) {
                this.mRoomElement = tRectangle;
                this.mRESnapping.prepareSnapping(this.mRoomElement);
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.setToolRunning(true);
                this.mRoomElement.interactors.showInteractors(true, true);
                this.mRoomElement.updateGeometry();
            }
        }
        else if (this.mRoomElement != null) {
            this.mPoints.push(tnewPos);
            if (this.mRoomElement.geometry.getType() === "Rectangle") {
                //(this.mRoomElement.geometry as Rectangle).setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
                this.stop();
            }
        }
    }
    checkInsertGrip() {
        if (this.mApp.model.selection.length < 1) {
            return (false);
        }
        const tsel = this.mApp.model.selection[0];
        if (!(tsel instanceof MainArticleElement)) {
            return (false);
        }
        const tBB = tsel.boundingBoxVisible;
        const twm = tsel.worldTransform;
        const tBBx = tBB.getSize().x;
        const tBBz = tBB.getSize().z;
        const tW = 1.5 * Math.ceil(tBBx / 1.5);
        const tL = 1 * Math.ceil(tBBz / 1);
        const tWH = tW * 0.5;
        const tLH = tL * 0.5;
        let tBBcenter = tBB.getCenter(twm);
        tBBcenter.y = 0;
        const tgridPoints = [];
        tgridPoints.push(new Vector3(-tWH, 0, tLH), new Vector3(-tWH, 0, -tLH), new Vector3(tWH, 0, -tLH), new Vector3(tWH, 0, tLH));
        const tRE_grid = this.mRoomManager._insertGrid(tgridPoints);
        if (tRE_grid != null) {
            tRE_grid.setPosition(tBBcenter);
            if (tsel.node.rotationQuaternion != null) {
                tRE_grid.node.rotationQuaternion = tsel.node.rotationQuaternion.clone();
            }
            tRE_grid.updateTransformation();
            this.mApp.model.setSelection([tRE_grid]);
            return (true);
        }
        return (false);
    }
    handlePDown_Grid(pPos, pState) {
        if (pPos == null)
            return;
        let tnewPos = this.performSnapping(pPos);
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            let tPos1 = tnewPos.clone();
            let tPos2 = tnewPos.clone().add(new Vector3(0, 0, -0.1));
            let tPos3 = tnewPos.clone().add(new Vector3(0.1, 0, -0.1));
            let tPos4 = tnewPos.clone().add(new Vector3(0.1, 0, 0));
            this.mPoints.push(tPos1);
            this.mPoints.push(tPos2);
            this.mPoints.push(tPos3);
            this.mPoints.push(tPos4);
            let tRectangle = this.mRoomManager._insertGrid(this.mPoints);
            if (tRectangle != null) {
                this.mRoomElement = tRectangle;
                // this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.setToolRunning(true);
                // this.mRoomElement.interactors.showInteractors(true, true);
                this.mRoomElement.updateGeometry();
            }
        }
        else if (this.mRoomElement != null) {
            this.mPoints.push(tnewPos);
            if (this.mRoomElement.geometry.getType() === "Grid") {
                //(this.mRoomElement.geometry as mdl.geo.Rectangle).setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
                this.stop();
            }
        }
    }
    handlePDown_Circle(pPos, pState) {
        if (pPos == null)
            return;
        let tnewPos = this.performSnapping(pPos);
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            let tPos1 = tnewPos.clone();
            let tPos2 = tnewPos.clone().add(new Vector3(0.05, 0, 0));
            this.mPoints.push(tPos1);
            this.mPoints.push(tPos2);
            let tCircle = this.mRoomManager._insertCircle(this.mPoints);
            if (tCircle != null) {
                this.mRoomElement = tCircle;
                this.mRESnapping.prepareSnapping(this.mRoomElement);
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.setToolRunning(true);
                this.mRoomElement.interactors.showInteractors(true, true);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
        }
        else {
            this.stop();
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_Line(pPos, pState) {
        if (pPos == null)
            return;
        let tnewPos = this.performSnapping(pPos);
        if (this.mGridSnapping && Util.vectorEquals3(pPos, tnewPos)) {
            return;
        }
        if (this.mGridSnapping && this.mselectedGrid != null) {
            tnewPos = Vector3.TransformCoordinates(tnewPos, this.mselectedGrid.transformInverted);
        }
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(tnewPos);
            this.mPoints.push(tnewPos);
            this.mFirstSpline = true;
            let tLine = null;
            if (this.mselectedGrid != null) {
                const tMatSet = {};
                tLine = this.mRoomManager._insertLine(this.mPoints, 'grassmats', 'grassmat1');
            }
            else {
                tLine = this.mRoomManager._insertLine(this.mPoints);
            }
            if (tLine != null) {
                this.mRoomElement = tLine;
                // store grid/roomelement connection in case of drawing line based
                // on grid
                if (this.mselectedGrid != null) {
                    this.mRoomElement.setWidth(this.mselectedGrid.width, false, false);
                    this.mRoomElement.setDepth(this.mselectedGrid.depth, false, false);
                    this.mRoomElement.setGridRE_REF(this.mselectedGrid);
                    this.mselectedGrid.setREforGrid_REF([this.mRoomElement]);
                    this.mRoomElement.setPosition(Vector3.Zero());
                    this.mApp.model.removeElement(this.mRoomElement, false, false);
                    this.mApp.model.addElement(this.mRoomElement, this.mselectedGrid.node);
                    this.mRoomElement.updateTransformation();
                }
                this.mRoomElement.setDrawingNew(true);
                if (!this.mGridSnapping) {
                    this.mRESnapping.prepareSnapping(this.mRoomElement);
                }
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.setToolRunning(true);
                this.mRoomElement.interactors.showInteractors(true, true);
            }
        }
        else {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else {
                        this.mPoints.push(tnewPos);
                        this.mDownPushed = true;
                    }
                }
                else {
                    this.mPoints.push(tnewPos);
                    this.mDownPushed = true;
                }
            }
            else if (this.mRoomElement != null) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    let tPlast = new Vector3(0, 0, 0);
                    tPlast.x = this.mPoints[0].x;
                    tPlast.y = this.mPoints[0].y;
                    tPlast.z = this.mPoints[0].z;
                    this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                    this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                    this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                    if (this.mRoomElement.geometry.getType() === "Line") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                    this.stop();
                }
                else if (this.mPoints.length >= 3) {
                    let tlastIdx = this.mPoints.length - 1;
                    if (Util.vectorEquals3(this.mPoints[tlastIdx], this.mPoints[tlastIdx - 1])) {
                        return;
                    }
                    this.mPoints.push(tnewPos);
                    if (this.mRoomElement.geometry.getType() === "Line") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
                else {
                    this.mPoints.push(tnewPos);
                    if (this.mRoomElement.geometry.getType() === "Line") {
                        this.mRoomElement.geometry.setPoints(this.mPoints, true);
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_CustomBuilding(pPos, pState) {
        if (pPos == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        if (this.mRoomManager != null && this.mRoomElement != null) {
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else if (this.mPoints.length > 2) {
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
            else if (this.mPoints.length > 0) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
            this.mRoomElement.interactors.showInteractors(true, true);
            this.mApp.viewer.requestRenderFrame();
            if (!this.mApp.model.layers.isLayerVisible("room:Building_Layer"))
                this.mRoomManager.setLayerVisibility_Buildings(true);
        }
        if (this.mPoints.length === 0) {
            this.mView = this.mRoomManager.view;
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(pPos);
            this.mPoints.push(pPos);
            this.mFirstSpline = true;
            let tCustomBuilding = this.mRoomManager.insertCustomBuilding(this.mPoints, undefined, 1).then((pCustomBuilding) => {
                if (pCustomBuilding != null) {
                    this.mRoomElement = pCustomBuilding;
                    this.mRoomElement.setMeshVisibility(0.5, true);
                    this.mRoomElement.setToolRunning(true);
                    this.mRoomElement.interactors.showInteractors(true, true);
                }
            });
        }
        else {
            tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else {
                        this.mPoints.push(pPos);
                        this.mDownPushed = true;
                    }
                }
                else {
                    this.mPoints.push(pPos);
                    this.mDownPushed = true;
                }
            }
            else if (this.mRoomElement == null)
                return;
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                let tPlast = new Vector3(0, 0, 0);
                tPlast.x = this.mPoints[0].x;
                tPlast.y = this.mPoints[0].y;
                tPlast.z = this.mPoints[0].z;
                this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                if (this.mRoomElement.geometry.getType() === "CustomBuilding") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop();
            }
            else if (this.mPoints.length >= 3) {
                let tlastIdx = this.mPoints.length - 1;
                if (Util.vectorEquals3(this.mPoints[tlastIdx], this.mPoints[tlastIdx - 1]))
                    return;
                this.mPoints.push(pPos);
                if (this.mRoomElement.geometry.getType() === "CustomBuilding") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
            else {
                this.mPoints.push(pPos);
                if (this.mRoomElement.geometry.getType() === "CustomBuilding") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_Road(pPos, pState) {
        if (pPos == null)
            return;
        if (this.mPoints.length === 0) {
            this.mView = this.mRoomManager.view;
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(pPos);
            this.mPoints.push(pPos);
            this.mFirstSpline = true;
            let tRoad = this.mRoomManager._insertRoad(this.mPoints, this.mCurvedRoad);
            if (tRoad != null) {
                this.mRoomElement = tRoad;
                this.mRoomElement.setToolRunning(true);
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.interactors.showInteractors(true, true);
            }
        }
        else {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else {
                        this.mPoints.push(pPos);
                        this.mDownPushed = true;
                    }
                }
                else {
                    this.mPoints.push(pPos);
                    this.mDownPushed = true;
                }
            }
            else if (this.mRoomElement == null)
                return;
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                let tPlast = new Vector3(0, 0, 0);
                tPlast.x = this.mPoints[0].x;
                tPlast.y = this.mPoints[0].y;
                tPlast.z = this.mPoints[0].z;
                this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                if (this.mRoomElement.geometry.getType() === "Road") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop(false);
            }
            else {
                this.mPoints.push(pPos);
                if (this.mRoomElement.geometry.getType() === "Road") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_Hedge(pPos, pState) {
        if (pPos == null)
            return;
        if (this.mPoints.length === 0) {
            this.mView = this.mRoomManager.view;
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(pPos);
            this.mPoints.push(pPos);
            this.mFirstSpline = true;
            let tHedge = this.mRoomManager._insertHedge(this.mPoints, this.mCurvedRoad);
            if (tHedge != null) {
                this.mRoomElement = tHedge;
                this.mRoomElement.setToolRunning(true);
                this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.interactors.showInteractors(true, true);
            }
        }
        else {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else {
                        this.mPoints.push(pPos);
                        this.mDownPushed = true;
                    }
                }
                else {
                    this.mPoints.push(pPos);
                    this.mDownPushed = true;
                }
            }
            else if (this.mRoomElement == null)
                return;
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                let tPlast = new Vector3(0, 0, 0);
                tPlast.x = this.mPoints[0].x;
                tPlast.y = this.mPoints[0].y;
                tPlast.z = this.mPoints[0].z;
                this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                if (this.mRoomElement.geometry.getType() === "Hedge") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop(false);
            }
            else {
                this.mPoints.push(pPos);
                if (this.mRoomElement.geometry.getType() === "Hedge") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_Fence(pPos, pState) {
        if (pPos == null)
            return;
        if (this.mPoints.length === 0) {
            this.mView = this.mRoomManager.view;
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(pPos);
            this.mPoints.push(pPos);
            this.mFirstSpline = true;
            let tFence = this.mRoomManager._insertFence(this.mPoints, this.mCurvedRoad);
            if (tFence != null) {
                this.mRoomElement = tFence;
                this.mRoomElement.setToolRunning(true);
                // this.mRoomElement.setMeshVisibility(0.5, true);
                this.mRoomElement.interactors.showInteractors(true, true);
            }
        }
        else {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1]))
                        this.mSecondSpline = true;
                    else {
                        this.mPoints.push(pPos);
                        this.mDownPushed = true;
                    }
                }
                else {
                    this.mPoints.push(pPos);
                    this.mDownPushed = true;
                }
            }
            else if (this.mRoomElement == null)
                return;
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                let tPlast = new Vector3(0, 0, 0);
                tPlast.x = this.mPoints[0].x;
                tPlast.y = this.mPoints[0].y;
                tPlast.z = this.mPoints[0].z;
                this.mPoints[this.mPoints.length - 1].x = tPlast.x;
                this.mPoints[this.mPoints.length - 1].y = tPlast.y;
                this.mPoints[this.mPoints.length - 1].z = tPlast.z;
                if (this.mRoomElement.geometry.getType() === "Fence") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop(false);
            }
            else {
                this.mPoints.push(pPos);
                if (this.mRoomElement.geometry.getType() === "Fence") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePDown_CameraPath(pPos, pState) {
        if (pPos == null)
            return;
        pPos.y = 0;
        let tnewPos = this.performSnapping(pPos);
        if (this.maddEnding != null) {
            tnewPos = Vector3.TransformCoordinates(tnewPos, this.mRoomElement.transformInverted);
        }
        if (this.mPoints.length === 0) {
            this.mTouchMode = pState.pointerType !== "mouse";
            this.mPoints.push(tnewPos);
            this.mPoints.push(tnewPos);
            this.mFirstSpline = true;
            let tcamPath = this.mRoomManager._insertCameraPath(this.mPoints);
            if (tcamPath != null) {
                this.mRoomElement = tcamPath;
                this.mRESnapping.prepareSnapping(this.mRoomElement);
                this.mRoomElement.setToolRunning(true);
            }
            else {
                this.stop();
            }
        }
        else {
            if (this.maddEnding != null) {
                if (this.maddEnding === AddEnding.Start) {
                    tnewPos.y = this.mPoints[0].y;
                }
                else {
                    tnewPos.y = this.mPoints[this.mPoints.length - 1].y;
                }
            }
            if (this.mTouchMode) {
                if (this.mPoints.length === 2) {
                    if (Util.vectorEquals3(this.mPoints[0], this.mPoints[1])) {
                        this.mSecondSpline = true;
                    }
                    else if (tnewPos != null) {
                        this.mPoints.push(tnewPos);
                        this.mDownPushed = true;
                    }
                }
                else if (tnewPos != null) {
                    this.mPoints.push(tnewPos);
                    this.mDownPushed = true;
                }
            }
            else if (tnewPos != null && this.mRoomElement != null) {
                const tcamPath = this.mRoomElement.geometry;
                if (this.mPoints.length >= 3) {
                    let tlastIdx = this.mPoints.length - 1;
                    if (Util.vectorEquals3(this.mPoints[tlastIdx], this.mPoints[tlastIdx - 1])) {
                        return;
                    }
                    if (this.maddEnding == null || this.maddEnding === AddEnding.End) {
                        this.mPoints.push(tnewPos);
                    }
                    else {
                        this.mPoints.unshift(tnewPos);
                    }
                    if (tcamPath.getType() === "CameraPath") {
                        tcamPath.setPoints(this.mPoints, true);
                        tcamPath.computeCamPathData();
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
                else {
                    if (this.maddEnding == null || this.maddEnding === AddEnding.End) {
                        this.mPoints.push(tnewPos);
                    }
                    else {
                        this.mPoints.unshift(tnewPos);
                    }
                    if (tcamPath.getType() === "CameraPath") {
                        tcamPath.setPoints(this.mPoints, true);
                        tcamPath.computeCamPathData();
                        this.mRoomElement.updateGeometry();
                        this.mApp.viewer.requestRenderFrame();
                    }
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_Spline(pPos, pDist) {
        if (pPos == null)
            return;
        //let tDist = Vector3.Distance(this.mPoints[0], pPos);
        //if (tDist < 0.3 && (this.mPoints.length >= 3)){
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
            if (!this.mDownPushed)
                this.mPoints.push(this.mPoints[0]);
            else
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
            if (this.mRoomElement.geometry.getType() === "Spline") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
            this.stop();
        }
        else {
            if (this.mTouchMode && this.mFirstSpline) {
                this.mPoints[1] = pPos;
                this.mFirstSpline = false;
            }
            else if (this.mSecondSpline) {
                this.mPoints[1] = pPos;
                this.mSecondSpline = false;
            }
            else if (!this.mDownPushed)
                this.mPoints.push(pPos);
            else
                this.mDownPushed = false;
            if (this.mRoomElement.geometry.getType() === "Spline") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_Line(pPos, pDist) {
        if (pPos == null || this.mRoomElement == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
            //let tDist = Vector3.Distance(this.mPoints[0], pPos);
            //if (tDist < 0.3 && (this.mPoints.length >= 3)){
            if (!this.mDownPushed)
                this.mPoints.push(this.mPoints[0]);
            else
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
            if (this.mRoomElement.geometry.getType() === "Line") {
                this.mRoomElement.geometry.setPoints(this.mPoints, true);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
            this.stop();
        }
        else {
            if (this.mTouchMode && this.mFirstSpline) {
                this.mPoints[1] = pPos;
                this.mFirstSpline = false;
            }
            else if (this.mSecondSpline) {
                this.mPoints[1] = pPos;
                this.mSecondSpline = false;
            }
            else if (!this.mDownPushed)
                this.mPoints.push(pPos);
            else
                this.mDownPushed = false;
            if (this.mRoomElement.geometry.getType() === "Line") {
                this.mRoomElement.geometry.setPoints(this.mPoints, true);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_CustomBuilding(pPos, pDist) {
        if (pPos == null || this.mRoomElement == null)
            return;
        //let tDist = Vector3.Distance(this.mPoints[0], pPos);
        //if (tDist < 0.3 && (this.mPoints.length >= 3)){
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
            if (!this.mDownPushed)
                this.mPoints.push(this.mPoints[0]);
            else
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
            if (this.mRoomElement.geometry.getType() === "CustomBuilding") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
            this.stop();
        }
        else {
            if (this.mTouchMode && this.mFirstSpline) {
                this.mPoints[1] = pPos;
                this.mFirstSpline = false;
            }
            else if (this.mSecondSpline) {
                this.mPoints[1] = pPos;
                this.mSecondSpline = false;
            }
            else if (!this.mDownPushed)
                this.mPoints.push(pPos);
            else
                this.mDownPushed = false;
            if (this.mRoomElement.geometry.getType() === "CustomBuilding") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
        }
    }
    handlePUp_Rectangle(pPos, pDist) {
        if (this.mTouchMode) {
            this.stop();
        }
    }
    handlePUp_Grid(pPos, pDist) {
        if (this.mTouchMode) {
            this.stop();
        }
    }
    handlePUp_Circle(pPos, pDist) {
        if (this.mTouchMode) {
            this.stop();
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_Road(pPos, pDist) {
        if (pPos != null && this.mRoomElement != null) {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
                if (!this.mDownPushed)
                    this.mPoints.push(this.mPoints[0]);
                else
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                if (this.mRoomElement.geometry.getType() === "Road") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop();
            }
            else {
                if (this.mTouchMode && this.mFirstSpline) {
                    this.mPoints[1] = pPos;
                    this.mFirstSpline = false;
                }
                else if (this.mSecondSpline) {
                    this.mPoints[1] = pPos;
                    this.mSecondSpline = false;
                }
                else if (!this.mDownPushed) {
                    this.mPoints.push(pPos);
                }
                else {
                    this.mDownPushed = false;
                }
                if (this.mRoomElement.geometry.getType() === "Road") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_Hedge(pPos, pDist) {
        if (pPos != null && this.mRoomElement != null) {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
                if (!this.mDownPushed)
                    this.mPoints.push(this.mPoints[0]);
                else
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                if (this.mRoomElement.geometry.getType() === "Hedge") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop();
            }
            else {
                if (this.mTouchMode && this.mFirstSpline) {
                    this.mPoints[1] = pPos;
                    this.mFirstSpline = false;
                }
                else if (this.mSecondSpline) {
                    this.mPoints[1] = pPos;
                    this.mSecondSpline = false;
                }
                else if (!this.mDownPushed) {
                    this.mPoints.push(pPos);
                }
                else {
                    this.mDownPushed = false;
                }
                if (this.mRoomElement.geometry.getType() === "Hedge") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_Fence(pPos, pDist) {
        if (pPos != null && this.mRoomElement != null) {
            let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
            if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
                if (!this.mDownPushed)
                    this.mPoints.push(this.mPoints[0]);
                else
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                if (this.mRoomElement.geometry.getType() === "Fence") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
                this.stop();
            }
            else {
                if (this.mTouchMode && this.mFirstSpline) {
                    this.mPoints[1] = pPos;
                    this.mFirstSpline = false;
                }
                else if (this.mSecondSpline) {
                    this.mPoints[1] = pPos;
                    this.mSecondSpline = false;
                }
                else if (!this.mDownPushed) {
                    this.mPoints.push(pPos);
                }
                else {
                    this.mDownPushed = false;
                }
                if (this.mRoomElement.geometry.getType() === "Fence") {
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                    this.mApp.viewer.requestRenderFrame();
                }
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePUp_CameraPath(pPos, pDist) {
        if (pPos == null)
            return;
        //let tDist = Vector3.Distance(this.mPoints[0], pPos);
        //if (tDist < 0.3 && (this.mPoints.length >= 3)){
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if ((Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) && (this.mPoints.length >= 3)) {
            if (!this.mDownPushed)
                this.mPoints.push(this.mPoints[0]);
            else
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
            if (this.mRoomElement.geometry.getType() === "CameraPath") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
            this.stop();
        }
        else {
            if (this.mTouchMode && this.mFirstSpline) {
                this.mPoints[1] = pPos;
                this.mFirstSpline = false;
            }
            else if (this.mSecondSpline) {
                this.mPoints[1] = pPos;
                this.mSecondSpline = false;
            }
            else if (!this.mDownPushed)
                this.mPoints.push(pPos);
            else
                this.mDownPushed = false;
            if (this.mRoomElement.geometry.getType() === "CameraPath") {
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
                this.mApp.viewer.requestRenderFrame();
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_Spline(pPos, pState) {
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if (pPos == null)
            return;
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        if (this.mTouchMode) {
            if (this.mPoints.length === 2 && this.mRoomElement != null) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2 && this.mRoomElement != null) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0 && tnewPos != null && this.mRoomElement != null) {
            if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_Line(pPos, pState) {
        if (pPos == null || this.mRoomElement == null) {
            return;
        }
        const tREgeo = this.mRoomElement.geometry;
        if (tREgeo == null) {
            return;
        }
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        if (this.mGridSnapping && this.mselectedGrid != null) {
            tnewPos = Vector3.TransformCoordinates(tnewPos, this.mselectedGrid.transformInverted);
        }
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                tREgeo.setPoints(this.mPoints, true);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    tREgeo.setPoints(this.mPoints, true);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    if (this.mRoomManager.shiftPressed) {
                        const tprevLine = tREgeo.getPrevLine();
                        if (tprevLine != null) {
                            tnewPos = Util.calcSnapPoint(this.mPoints[this.mPoints.length - 2], tnewPos, 45, tprevLine.Start, tprevLine.End);
                        }
                        else {
                            tnewPos = Util.calcSnapPoint(this.mPoints[this.mPoints.length - 2], tnewPos, 45);
                        }
                    }
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    tREgeo.setPoints(this.mPoints, true);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0) {
            if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                tREgeo.setPoints(this.mPoints, true);
                this.mRoomElement.updateGeometry();
            }
            else {
                if (this.mRoomManager.shiftPressed) {
                    const tprevLine = tREgeo.getPrevLine();
                    if (tprevLine != null) {
                        const tcurrLine = {};
                        tcurrLine.Start = tprevLine.End.clone();
                        tcurrLine.End = tnewPos.clone();
                        tnewPos = Util.rotateVectorSnapping(tprevLine, tcurrLine, 45);
                    }
                }
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                tREgeo.setPoints(this.mPoints, true);
                this.mRoomElement.updateGeometry();
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mApp.viewer.requestRenderFrame();
    }
    handlePMove_CustomBuilding(pPos, pState) {
        if (pPos == null || this.mRoomElement == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
        else if (this.mPoints.length > 0) {
            if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mApp.viewer.requestRenderFrame();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_Rectangle(pPos, pState) {
        if (pPos == null || this.mRoomElement == null || this.mPoints.length === 0)
            return;
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        let tPoints = [];
        for (let tPoint of this.mPoints) {
            tPoints.push(tPoint.clone());
        }
        if (this.mRoomManager.shiftPressed) {
            let tdistX = Math.abs(tnewPos.x - this.mPoints[0].x);
            let tdistZ = Math.abs(tnewPos.z - this.mPoints[0].z);
            if (tdistX >= tdistZ) {
                if (tnewPos.z > this.mPoints[0].z)
                    tnewPos.z = this.mPoints[0].z + tdistX;
                else
                    tnewPos.z = this.mPoints[0].z - tdistX;
            }
            else if (tnewPos.x > this.mPoints[0].x)
                tnewPos.x = this.mPoints[0].x + tdistZ;
            else
                tnewPos.x = this.mPoints[0].x - tdistZ;
        }
        this.mPoints[3].x = tnewPos.x;
        this.mPoints[1].z = tnewPos.z;
        this.mPoints[2] = tnewPos;
        let tRes = this.mRoomElement.geometry.setPoints(this.mPoints);
        if (!tRes) {
            this.mPoints = [];
            for (let tPoint of tPoints) {
                this.mPoints.push(tPoint.clone());
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mRoomElement.updateGeometry();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_Grid(pPos, pState) {
        if (pPos == null || this.mRoomElement == null || this.mPoints.length === 0)
            return;
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        let tPoints = [];
        for (let tPoint of this.mPoints) {
            tPoints.push(tPoint.clone());
        }
        this.mPoints[3].x = tnewPos.x;
        this.mPoints[1].z = tnewPos.z;
        this.mPoints[2] = tnewPos;
        let tRes = this.mRoomElement.geometry.setPoints(this.mPoints);
        if (!tRes) {
            this.mPoints = [];
            this.mPoints = this.mRoomElement.geometry.getPoints().slice();
        }
        // this.mRoomElement.interactors.showInteractors(true, true);
        this.mRoomElement.updateGeometry();
    }
    handlePMove_Circle(pPos, pState) {
        if (pPos == null || this.mRoomElement == null || this.mPoints.length === 0)
            return;
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        this.mPoints[1] = tnewPos;
        if (this.mRoomElement != null) {
            this.mRoomElement.geometry.setPoints(this.mPoints);
            this.mRoomElement.interactors.showInteractors(true, true);
            this.mRoomElement.updateGeometry();
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_Road(pPos, pState) {
        if (pPos == null || this.mRoomElement == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = pPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0) {
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mApp.viewer.requestRenderFrame();
    }
    handlePMove_Hedge(pPos, pState) {
        if (pPos == null || this.mRoomElement == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = pPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0) {
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mApp.viewer.requestRenderFrame();
    }
    handlePMove_Fence(pPos, pState) {
        if (pPos == null || this.mRoomElement == null)
            return;
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = pPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0) {
            if (Util.vectorEquals3(pPos, this.mPoints[0], tscaleFak)) {
                this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else {
                this.mPoints[this.mPoints.length - 1] = pPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
        }
        this.mRoomElement.interactors.showInteractors(true, true);
        this.mApp.viewer.requestRenderFrame();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    handlePMove_CameraPath(pPos, pState) {
        if (pPos == null || this.mRoomElement == null) {
            return;
        }
        let tscaleFak = this.getScreenScaleFactor(this.mPoints[0]);
        pPos.y = 0;
        let tnewPos = this.mRESnapping.snap(pPos, this.mView);
        if (this.maddEnding != null) {
            tnewPos = Vector3.TransformCoordinates(tnewPos, this.mRoomElement.transformInverted);
            tnewPos.y = 0;
        }
        if (this.mTouchMode) {
            if (this.mPoints.length === 2) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
                this.mRoomElement.geometry.setPoints(this.mPoints);
                this.mRoomElement.updateGeometry();
            }
            else if (this.mPoints.length > 2) {
                if (Util.vectorEquals3(tnewPos, this.mPoints[0], tscaleFak)) {
                    this.mPoints[this.mPoints.length - 1] = this.mPoints[0];
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
                else {
                    this.mPoints[this.mPoints.length - 1] = tnewPos;
                    this.mRoomElement.geometry.setPoints(this.mPoints);
                    this.mRoomElement.updateGeometry();
                }
            }
        }
        else if (this.mPoints.length > 0 && tnewPos != null) {
            if (this.maddEnding == null || this.maddEnding === AddEnding.End) {
                this.mPoints[this.mPoints.length - 1] = tnewPos;
            }
            else {
                this.mPoints[0] = tnewPos;
            }
            this.mRoomElement.geometry.setPoints(this.mPoints);
            this.mRoomElement.updateGeometry();
        }
    }
    startArea2D(pPos) {
        if (pPos == null || this.mView == null)
            return;
        this.mApp.viewer.requestRenderFrame();
    }
    finishSpline(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tSpline = this.mRoomElement.geometry;
            let tmeshCenter = new Vector3(0, 0, 0);
            if (this.mRoomElement.CAG != null)
                tmeshCenter = Util.getCenterofCAG(this.mRoomElement.CAG);
            let t_points = Util.correctPolygonDirection3(this.mPoints);
            let tHPoints = [];
            for (let tP of t_points) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            //cancel tool
            if (tHPoints.length < 3) {
                this.mRoomElement.dispose();
                return;
            }
            if (Util.vectorEquals3(tHPoints[tHPoints.length - 2], tHPoints[tHPoints.length - 1]))
                tHPoints.pop();
            tSpline.setPoints(tHPoints);
            this.mRoomElement.updateGeometry();
            tmeshCenter.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
            this.mRoomElement.setPosition(tmeshCenter);
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    finishRectangle() {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRightClicked) {
            //cancel tool
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tRectangle = this.mRoomElement.geometry;
            tRectangle.checkPointOrder();
            let tmeshCenter = new Vector3(0, 0, 0);
            if (this.mRoomElement.CAG != null)
                tmeshCenter = Util.getCenterofCAG(this.mRoomElement.CAG);
            let tRectanglePoints = tRectangle.getPoints();
            let tHPoints = [];
            for (let tP of tRectanglePoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            tRectangle.setPoints(tHPoints);
            this.mRoomElement.updateGeometry();
            tmeshCenter.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
            this.mRoomElement.setPosition(tmeshCenter);
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishLine() {
        if (this.mRoomElement == null) {
            return;
        }
        // finish line based on grid
        if (this.mRoomElement.GridRE_REF != null) {
            this.finishLine_Grid();
            return;
        }
        if (!this.mRightClicked) {
            this.mPoints.pop();
        }
        if (this.mPoints.length < 3) {
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        this.mRoomElement.setDrawingNew(false);
        this.mRoomElement.setToolRunning(false);
        let tLine = this.mRoomElement.geometry;
        tLine.setPoints(this.mPoints);
        let tmeshCenter = new Vector3(0, 0, 0);
        if (this.mRoomElement.CAG != null)
            tmeshCenter = Util.getCenterofCAG(this.mRoomElement.CAG);
        let tLinePoints = tLine.getPoints();
        let tHPoints = [];
        for (let tP of tLinePoints) {
            let tHP = tP.subtract(tmeshCenter);
            tHPoints.push(tHP);
        }
        //cancel tool
        if (tHPoints.length < 3) {
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        if (Util.vectorEquals3(tHPoints[tHPoints.length - 2], tHPoints[tHPoints.length - 1]))
            tHPoints.pop();
        tLine.setPoints(tHPoints, false);
        this.mRoomElement.updateGeometry();
        tmeshCenter.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
        this.mRoomElement.setPosition(tmeshCenter);
        this.mApp.viewer.requestRenderFrame();
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishLine_Grid() {
        if (this.mRoomElement == null) {
            return;
        }
        if (!this.mRightClicked) {
            this.mPoints.pop();
        }
        if (this.mPoints.length < 3) {
            this.mApp.model.removeElement(this.mRoomElement, true, true);
            this.mRoomManager._removeRoomElement(this.mRoomElement, true);
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            if (this.mselectedGrid != null) {
                this.mApp.model.setSelection([this.mselectedGrid]);
            }
            return;
        }
        this.mRoomElement.setDrawingNew(false);
        this.mRoomElement.setToolRunning(false);
        let tLine = this.mRoomElement.geometry;
        tLine.setPoints(this.mPoints);
        let tLinePoints = tLine.getPoints();
        let tHPoints = tLinePoints.slice();
        //cancel tool
        if (tHPoints.length < 3) {
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        if (Util.vectorEquals3(tHPoints[tHPoints.length - 2], tHPoints[tHPoints.length - 1]))
            tHPoints.pop();
        tLine.setPoints(tHPoints, false);
        this.mRoomElement.updateGeometry();
        this.mApp.viewer.requestRenderFrame();
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            // in case of grid base Line:
            // connect grid with line
            if (this.mRoomElement.GridRE_REF != null) {
                // re-positioning line shape before connecting
                this.mRoomElement.setPosition(Vector3.Zero());
                this.mApp.model.removeElement(this.mRoomElement, false, false);
                this.mApp.model.addElement(this.mRoomElement, this.mRoomElement.GridRE_REF.node);
                this.mRoomElement.GridRE_REF.setREforGrid_REF([this.mRoomElement]);
                this.mRoomElement.GridRE_REF.updateTransformation();
                this.mRoomElement.countGridFields(this.mRoomElement.CAG);
                const tREGridNo = this.mRoomManager._getNextREGridId();
                this.mRoomElement.setRELabel("Grass mat [" + tREGridNo.toString() + "]");
                this.mApp.model.setSelection([this.mRoomElement.GridRE_REF]);
                this.mApp.model.setSubElementSelection(this.mRoomElement.GridRE_REF, this.mRoomElement);
                this.mRoomElement.setMeshVisibility(1);
            }
            this.mRoomManager.TransformShape();
        });
    }
    finishCustomBuilding(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tBuildingPlan = this.mRoomElement.geometry;
            let tmeshCenter = new Vector3(0, 0, 0);
            if (this.mRoomElement.CAG != null)
                tmeshCenter = Util.getCenterofCAG(this.mRoomElement.CAG);
            let tBuildingPoints = tBuildingPlan.getPoints();
            let tHPoints = [];
            for (let tP of tBuildingPoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            if (!Util.samePointsV3(tHPoints[0], tHPoints[tHPoints.length - 1], 0.00001) &&
                premoveLastPoint) {
                tHPoints.pop();
            }
            //cancel tool
            if (tHPoints.length < 3) {
                this.mRoomElement.showInteractors(false);
                this.mRoomManager._removeRoomElement(this.mRoomElement, true);
                this.mRoomElement.dispose();
                return;
            }
            // auto close polygon
            if (!Util.samePointsV3(tHPoints[0], tHPoints[tHPoints.length - 1], 0.00001))
                tHPoints.push(tHPoints[0]);
            tBuildingPlan.setPoints(tHPoints);
            this.mRoomElement.updateGeometry(false);
            tmeshCenter.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
            this.mRoomElement.setPosition(tmeshCenter);
            // store original parameters (height, points, position)
            this.mRoomElement.Params.ElementOriginalPositionX = tmeshCenter.x;
            this.mRoomElement.Params.ElementOriginalPositionY = tmeshCenter.y;
            this.mRoomElement.Params.ElementOriginalPositionZ = tmeshCenter.z;
            this.mRoomElement.Params.ElementOriginalPoints = tHPoints.slice();
            this.mRoomElement.Params.ElementOriginalHeight = this.mRoomElement.height;
            this.mRoomManager.addBuilding(this.mRoomElement);
            this.mRoomManager.addInitialBuilding(this.mRoomElement);
            this.mRoomManager.addInitialBuilding(this.mRoomElement);
            this.mApp.viewer.requestRenderFrame();
        }
        this.mApp.model.setSelection([this.mRoomElement]);
    }
    finishCircle() {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRightClicked) {
            //cancel tool
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            this.mRoomElement.geometry.setPoints(this.mPoints);
            let tnodePos = this.mRoomElement.node.absolutePosition.clone();
            tnodePos.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
            this.mRoomElement.setPosition(tnodePos);
            this.mRoomElement.updateGeometry();
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishRoad(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tRoad = this.mRoomElement.geometry;
            let tmeshCenter = new Vector3(0, 0, 0);
            let tLinePoints = tRoad.getPoints();
            let tHPoints = [];
            for (let tP of tLinePoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            //remove mesh if less than 2 points
            if (tHPoints.length < 2) {
                this.mRoomElement.showInteractors(false);
                this.mRoomElement.interactors.dispose();
                this.mRoomElement.dispose();
                return;
            }
            if (tHPoints.length === 2) {
                const tDist = Vector3.Distance(tHPoints[0], tHPoints[1]);
                if (tDist < 0.1) {
                    this.mRoomElement.showInteractors(false);
                    this.mRoomElement.interactors.dispose();
                    this.mRoomElement.dispose();
                    return;
                }
            }
            // remove last point if it's equal to last but one
            if (tHPoints.length > 2) {
                const tlen = tHPoints.length;
                const tPP = tHPoints[tlen - 2];
                const tPL = tHPoints[tlen - 1];
                if (Util.vectorEquals3(tPP, tPL) || premoveLastPoint) {
                    tHPoints.pop();
                }
            }
            tRoad.setPoints(tHPoints);
            if (this.mRoomElement.CAG !== null)
                this.mRoomElement.setCAG(null);
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tREgeo = this.mRoomElement.geometry;
            let tPoints = tREgeo.getPoints();
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tREgeo.setPoints(tPoints);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, true);
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishHedge(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tHedge = this.mRoomElement.geometry;
            let tmeshCenter = new Vector3(0, 0, 0);
            let tLinePoints = tHedge.getPoints();
            let tHPoints = [];
            for (let tP of tLinePoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            //remove mesh if less than 2 points
            if (tHPoints.length < 2) {
                this.mRoomElement.showInteractors(false);
                this.mRoomElement.interactors.dispose();
                this.mRoomElement.dispose();
                return;
            }
            if (tHPoints.length === 2) {
                const tDist = Vector3.Distance(tHPoints[0], tHPoints[1]);
                if (tDist < 0.1) {
                    this.mRoomElement.showInteractors(false);
                    this.mRoomElement.interactors.dispose();
                    this.mRoomElement.dispose();
                    return;
                }
            }
            // remove last point if it's equal to last but one
            if (tHPoints.length > 2) {
                const tlen = tHPoints.length;
                const tPP = tHPoints[tlen - 2];
                const tPL = tHPoints[tlen - 1];
                if (Util.vectorEquals3(tPP, tPL) || premoveLastPoint) {
                    tHPoints.pop();
                }
            }
            tHedge.setPoints(tHPoints);
            if (this.mRoomElement.CAG !== null)
                this.mRoomElement.setCAG(null);
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tREgeo = this.mRoomElement.geometry;
            let tPoints = tREgeo.getPoints();
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tREgeo.setPoints(tPoints);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, true);
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishFence(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tHedge = this.mRoomElement.geometry;
            let tmeshCenter = new Vector3(0, 0, 0);
            let tLinePoints = tHedge.getPoints();
            let tHPoints = [];
            for (let tP of tLinePoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            //remove mesh if less than 2 points
            if (tHPoints.length < 2) {
                this.mRoomElement.showInteractors(false);
                this.mRoomElement.dispose();
                return;
            }
            if (tHPoints.length === 2) {
                const tDist = Vector3.Distance(tHPoints[0], tHPoints[1]);
                if (tDist < 0.1) {
                    this.mRoomElement.showInteractors(false);
                    this.mRoomElement.interactors.dispose();
                    this.mRoomElement.dispose();
                    return;
                }
            }
            // remove last point if it's equal to last but one
            if (tHPoints.length > 2) {
                const tlen = tHPoints.length;
                const tPP = tHPoints[tlen - 2];
                const tPL = tHPoints[tlen - 1];
                if (Util.vectorEquals3(tPP, tPL) || premoveLastPoint) {
                    tHPoints.pop();
                }
            }
            tHedge.setPoints(tHPoints);
            if (this.mRoomElement.CAG !== null)
                this.mRoomElement.setCAG(null);
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tREgeo = this.mRoomElement.geometry;
            let tPoints = tREgeo.getPoints();
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tREgeo.setPoints(tPoints, true);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, true);
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
    // tslint:disable-next-line:cyclomatic-complexity
    finishCameraPath(premoveLastPoint) {
        if (this.mRoomElement == null) {
            return;
        }
        this.mRoomElement.setToolRunning(false);
        let tcamPath = this.mRoomElement.geometry;
        if (this.maddEnding == null) {
            let tmeshCenter = new Vector3(0, 0, 0);
            tmeshCenter = Util.getCenterofPolygon(this.mPoints);
            let tHPoints = [];
            for (let tP of this.mPoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            //cancel tool
            if (tHPoints.length < 2) {
                this.mRoomElement.dispose();
                return;
            }
            if (tHPoints.length === 2 && !this.mRightClicked) {
                this.mRoomElement.dispose();
                return;
            }
            if (this.maddEnding == null) {
                this.mRoomManager.eventCameraPathAdded.trigger(this.mRoomManager);
            }
            if (Util.vectorEquals3(tHPoints[tHPoints.length - 2], tHPoints[tHPoints.length - 1]))
                tHPoints.pop();
            tcamPath.setPoints(tHPoints);
            tmeshCenter.y = this.mRoomElement.height;
            this.mRoomElement.setPosition(tmeshCenter);
        }
        else {
            // center polygon points
            let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
            let tPoints = tcamPath.getPoints();
            if (premoveLastPoint && tPoints.length > 2) {
                if (this.maddEnding === AddEnding.Start) {
                    tPoints.shift();
                }
                else {
                    tPoints.pop();
                }
            }
            let tpolyCenter = Util.getCenterofPolygon(tPoints);
            let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
            let tcurrPos = this.mRoomElement.position.clone();
            tPoints = Util.centerPolygon(tPoints);
            tcamPath.setPoints(tPoints);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
        }
        tcamPath.computeCamPathData(CameraPath.splitPath);
        this.mRoomElement.updateGeometry();
        this.mApp.viewer.requestRenderFrame();
        if (this.maddEnding == null) {
            let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
            this.mApp.commands.executeCommand(tCmd).then(() => {
                // this.mRoomManager.TransformShape();
                this.mRoomManager._addCamData();
                this.mApp.model.setSelection([this.mRoomElement]);
            });
        }
        else {
            this.mRoomManager._addCamData();
            this.mApp.model.setSelection([this.mRoomElement]);
        }
    }
    finishGrid() {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRightClicked) {
            //cancel tool
            this.mRoomElement.showInteractors(false);
            this.mRoomElement.dispose();
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
            let tGrid = this.mRoomElement.geometry;
            tGrid.checkPointOrder();
            let tmeshCenter = tGrid.center().clone();
            let tRectanglePoints = tGrid.getPoints();
            let tHPoints = [];
            for (let tP of tRectanglePoints) {
                let tHP = tP.subtract(tmeshCenter);
                tHPoints.push(tHP);
            }
            tGrid.setPoints(tHPoints);
            this.mRoomElement.updateGeometry();
            tmeshCenter.y = RoomManager.ROOM_2dSHAPE_POSITION_DEFAULT_Y;
            this.mRoomElement.setPosition(tmeshCenter);
            this.mApp.viewer.requestRenderFrame();
        }
        let tCmd = new InsertElements(this.mApp, [this.mRoomElement]);
        this.mApp.commands.executeCommand(tCmd).then(() => {
            this.mRoomManager.TransformShape();
            this.mApp.model.setSelection([this.mRoomElement]);
        });
    }
}
